// src/modules/marketplace/components/realization/filterUrl.ts

import parseISO from "date-fns/parseISO/index.js"

/**
 * Strip empty arrays and nullish values so we never send false filters to the
 * server or store empty values in state.
 */
export const cleanFilters = <T extends object>(filters: T): T =>
  Object.fromEntries(
    Object.entries(filters).filter(([, v]) =>
      Array.isArray(v) ? v.length > 0 : v != null,
    ),
  ) as T

/** Parse a yyyy-MM-dd date param, falling back when missing/invalid. */
export const parseDateParam = (
  raw: string | undefined,
  fallback: Date | null,
): Date | null => {
  if (!raw) return fallback
  const date = parseISO(raw)
  return Number.isNaN(date.getTime()) ? fallback : date
}
